// Common Indian medicines database with typical dosages
// Covers generics and popular Indian brands

export const MEDICINES_DATABASE = [
  // Diabetes
  { name: "Metformin", category: "Diabetes", dosages: ["250mg", "500mg", "850mg", "1000mg"] },
  { name: "Glimepiride", category: "Diabetes", dosages: ["1mg", "2mg", "3mg", "4mg"] },
  { name: "Gliclazide", category: "Diabetes", dosages: ["40mg", "80mg"] },
  { name: "Sitagliptin", category: "Diabetes", dosages: ["25mg", "50mg", "100mg"] },
  { name: "Vildagliptin", category: "Diabetes", dosages: ["50mg"] },
  { name: "Pioglitazone", category: "Diabetes", dosages: ["15mg", "30mg", "45mg"] },
  { name: "Insulin Glargine", category: "Diabetes", dosages: ["100 IU/ml"] },
  { name: "Insulin Regular", category: "Diabetes", dosages: ["40 IU/ml", "100 IU/ml"] },
  
  // Blood Pressure / Heart
  { name: "Amlodipine", category: "Blood Pressure", dosages: ["2.5mg", "5mg", "10mg"] },
  { name: "Telmisartan", category: "Blood Pressure", dosages: ["20mg", "40mg", "80mg"] },
  { name: "Losartan", category: "Blood Pressure", dosages: ["25mg", "50mg", "100mg"] },
  { name: "Ramipril", category: "Blood Pressure", dosages: ["2.5mg", "5mg", "10mg"] },
  { name: "Enalapril", category: "Blood Pressure", dosages: ["2.5mg", "5mg", "10mg"] },
  { name: "Atenolol", category: "Blood Pressure", dosages: ["25mg", "50mg", "100mg"] },
  { name: "Metoprolol", category: "Blood Pressure", dosages: ["25mg", "50mg", "100mg"] },
  { name: "Nebivolol", category: "Blood Pressure", dosages: ["2.5mg", "5mg", "10mg"] },
  { name: "Hydrochlorothiazide", category: "Blood Pressure", dosages: ["12.5mg", "25mg"] },
  { name: "Furosemide", category: "Blood Pressure", dosages: ["20mg", "40mg", "80mg"] },
  { name: "Spironolactone", category: "Blood Pressure", dosages: ["25mg", "50mg", "100mg"] },
  
  // Cholesterol
  { name: "Atorvastatin", category: "Cholesterol", dosages: ["10mg", "20mg", "40mg", "80mg"] },
  { name: "Rosuvastatin", category: "Cholesterol", dosages: ["5mg", "10mg", "20mg", "40mg"] },
  { name: "Fenofibrate", category: "Cholesterol", dosages: ["145mg", "160mg", "200mg"] },
  
  // Pain / Fever
  { name: "Paracetamol", category: "Pain/Fever", dosages: ["325mg", "500mg", "650mg", "1000mg"] },
  { name: "Ibuprofen", category: "Pain/Fever", dosages: ["200mg", "400mg", "600mg"] },
  { name: "Diclofenac", category: "Pain/Fever", dosages: ["50mg", "75mg", "100mg"] },
  { name: "Aceclofenac", category: "Pain/Fever", dosages: ["100mg", "200mg"] },
  { name: "Naproxen", category: "Pain/Fever", dosages: ["250mg", "500mg"] },
  { name: "Tramadol", category: "Pain/Fever", dosages: ["50mg", "100mg"] },
  { name: "Aspirin", category: "Pain/Fever", dosages: ["75mg", "150mg", "325mg"] },
  
  // Antibiotics
  { name: "Amoxicillin", category: "Antibiotic", dosages: ["250mg", "500mg", "875mg"] },
  { name: "Azithromycin", category: "Antibiotic", dosages: ["250mg", "500mg"] },
  { name: "Ciprofloxacin", category: "Antibiotic", dosages: ["250mg", "500mg", "750mg"] },
  { name: "Levofloxacin", category: "Antibiotic", dosages: ["250mg", "500mg", "750mg"] },
  { name: "Ofloxacin", category: "Antibiotic", dosages: ["200mg", "400mg"] },
  { name: "Cefixime", category: "Antibiotic", dosages: ["100mg", "200mg", "400mg"] },
  { name: "Cefpodoxime", category: "Antibiotic", dosages: ["100mg", "200mg"] },
  { name: "Doxycycline", category: "Antibiotic", dosages: ["100mg"] },
  { name: "Metronidazole", category: "Antibiotic", dosages: ["200mg", "400mg"] },
  { name: "Nitrofurantoin", category: "Antibiotic", dosages: ["50mg", "100mg"] },
  { name: "Norfloxacin", category: "Antibiotic", dosages: ["400mg"] },
  
  // Gastric / Acidity
  { name: "Omeprazole", category: "Gastric", dosages: ["20mg", "40mg"] },
  { name: "Pantoprazole", category: "Gastric", dosages: ["20mg", "40mg"] },
  { name: "Rabeprazole", category: "Gastric", dosages: ["10mg", "20mg"] },
  { name: "Esomeprazole", category: "Gastric", dosages: ["20mg", "40mg"] },
  { name: "Ranitidine", category: "Gastric", dosages: ["150mg", "300mg"] },
  { name: "Domperidone", category: "Gastric", dosages: ["10mg"] },
  { name: "Ondansetron", category: "Gastric", dosages: ["4mg", "8mg"] },
  { name: "Sucralfate", category: "Gastric", dosages: ["500mg", "1g"] },
  
  // Allergy / Cold
  { name: "Cetirizine", category: "Allergy", dosages: ["5mg", "10mg"] },
  { name: "Levocetirizine", category: "Allergy", dosages: ["5mg"] },
  { name: "Fexofenadine", category: "Allergy", dosages: ["120mg", "180mg"] },
  { name: "Loratadine", category: "Allergy", dosages: ["10mg"] },
  { name: "Montelukast", category: "Allergy", dosages: ["4mg", "5mg", "10mg"] },
  { name: "Chlorpheniramine", category: "Allergy", dosages: ["4mg"] },
  
  // Respiratory
  { name: "Salbutamol", category: "Respiratory", dosages: ["2mg", "4mg", "100mcg inhaler"] },
  { name: "Budesonide", category: "Respiratory", dosages: ["100mcg", "200mcg", "400mcg"] },
  { name: "Montelukast", category: "Respiratory", dosages: ["10mg"] },
  { name: "Theophylline", category: "Respiratory", dosages: ["100mg", "200mg", "300mg"] },
  { name: "Codeine", category: "Respiratory", dosages: ["10mg", "15mg", "30mg"] },
  { name: "Dextromethorphan", category: "Respiratory", dosages: ["10mg", "15mg"] },
  
  // Thyroid
  { name: "Levothyroxine", category: "Thyroid", dosages: ["25mcg", "50mcg", "75mcg", "100mcg", "125mcg"] },
  { name: "Thyroxine", category: "Thyroid", dosages: ["25mcg", "50mcg", "75mcg", "100mcg"] },
  { name: "Carbimazole", category: "Thyroid", dosages: ["5mg", "10mg", "20mg"] },
  
  // Vitamins / Supplements
  { name: "Vitamin D3", category: "Supplement", dosages: ["1000 IU", "2000 IU", "60000 IU"] },
  { name: "Vitamin B12", category: "Supplement", dosages: ["500mcg", "1000mcg", "1500mcg"] },
  { name: "Calcium + D3", category: "Supplement", dosages: ["500mg", "1000mg"] },
  { name: "Iron + Folic Acid", category: "Supplement", dosages: ["100mg+0.5mg"] },
  { name: "Folic Acid", category: "Supplement", dosages: ["1mg", "5mg"] },
  { name: "Multivitamin", category: "Supplement", dosages: ["1 tablet"] },
  { name: "Zinc", category: "Supplement", dosages: ["20mg", "50mg"] },
  { name: "Omega-3", category: "Supplement", dosages: ["500mg", "1000mg"] },
  
  // Mental Health
  { name: "Escitalopram", category: "Mental Health", dosages: ["5mg", "10mg", "20mg"] },
  { name: "Sertraline", category: "Mental Health", dosages: ["25mg", "50mg", "100mg"] },
  { name: "Fluoxetine", category: "Mental Health", dosages: ["20mg", "40mg", "60mg"] },
  { name: "Amitriptyline", category: "Mental Health", dosages: ["10mg", "25mg", "50mg"] },
  { name: "Clonazepam", category: "Mental Health", dosages: ["0.25mg", "0.5mg", "1mg", "2mg"] },
  { name: "Alprazolam", category: "Mental Health", dosages: ["0.25mg", "0.5mg", "1mg"] },
  { name: "Lorazepam", category: "Mental Health", dosages: ["1mg", "2mg"] },
  
  // Bone / Joint
  { name: "Calcium Carbonate", category: "Bone", dosages: ["500mg", "1000mg", "1250mg"] },
  { name: "Alendronate", category: "Bone", dosages: ["35mg", "70mg"] },
  { name: "Glucosamine", category: "Bone", dosages: ["500mg", "750mg", "1500mg"] },
  { name: "Collagen", category: "Bone", dosages: ["1g", "2g", "5g"] },
  
  // Skin
  { name: "Fluconazole", category: "Antifungal", dosages: ["50mg", "150mg", "200mg"] },
  { name: "Terbinafine", category: "Antifungal", dosages: ["250mg"] },
  { name: "Itraconazole", category: "Antifungal", dosages: ["100mg", "200mg"] },
  { name: "Ketoconazole", category: "Antifungal", dosages: ["200mg"] },
  
  // Popular Indian Brands
  { name: "Crocin", category: "Pain/Fever", dosages: ["500mg", "650mg"] },
  { name: "Dolo", category: "Pain/Fever", dosages: ["650mg"] },
  { name: "Calpol", category: "Pain/Fever", dosages: ["250mg", "500mg"] },
  { name: "Combiflam", category: "Pain/Fever", dosages: ["400mg+325mg"] },
  { name: "Disprin", category: "Pain/Fever", dosages: ["350mg", "500mg"] },
  { name: "Voveran", category: "Pain/Fever", dosages: ["50mg", "100mg"] },
  { name: "Zerodol", category: "Pain/Fever", dosages: ["100mg"] },
  { name: "Shelcal", category: "Supplement", dosages: ["500mg"] },
  { name: "Becosules", category: "Supplement", dosages: ["1 capsule"] },
  { name: "Zincovit", category: "Supplement", dosages: ["1 tablet"] },
  { name: "Liv 52", category: "Liver", dosages: ["2 tablets"] },
  { name: "Digene", category: "Gastric", dosages: ["1-2 tablets"] },
  { name: "Gelusil", category: "Gastric", dosages: ["1-2 tablets"] },
  { name: "ENO", category: "Gastric", dosages: ["1 sachet"] },
  { name: "Allegra", category: "Allergy", dosages: ["120mg", "180mg"] },
  { name: "Montair", category: "Allergy", dosages: ["10mg"] },
  { name: "Asthalin", category: "Respiratory", dosages: ["2mg", "4mg", "inhaler"] },
  { name: "Foracort", category: "Respiratory", dosages: ["200mcg", "400mcg"] },
  { name: "Glycomet", category: "Diabetes", dosages: ["250mg", "500mg", "850mg", "1000mg"] },
  { name: "Amaryl", category: "Diabetes", dosages: ["1mg", "2mg", "3mg", "4mg"] },
  { name: "Jalra", category: "Diabetes", dosages: ["50mg", "100mg"] },
  { name: "Telma", category: "Blood Pressure", dosages: ["20mg", "40mg", "80mg"] },
  { name: "Amlokind", category: "Blood Pressure", dosages: ["5mg", "10mg"] },
  { name: "Ecosprin", category: "Heart", dosages: ["75mg", "150mg"] },
  { name: "Clopitab", category: "Heart", dosages: ["75mg"] },
  { name: "Atorva", category: "Cholesterol", dosages: ["10mg", "20mg", "40mg"] },
  { name: "Rosuvas", category: "Cholesterol", dosages: ["10mg", "20mg"] },
  { name: "Pan", category: "Gastric", dosages: ["40mg"] },
  { name: "Nexpro", category: "Gastric", dosages: ["20mg", "40mg"] },
  { name: "Rantac", category: "Gastric", dosages: ["150mg", "300mg"] },
  { name: "Zinetac", category: "Gastric", dosages: ["150mg"] },
  { name: "Emeset", category: "Gastric", dosages: ["4mg", "8mg"] },
  { name: "Perinorm", category: "Gastric", dosages: ["10mg"] },
  { name: "Thyronorm", category: "Thyroid", dosages: ["25mcg", "50mcg", "75mcg", "100mcg"] },
  { name: "Eltroxin", category: "Thyroid", dosages: ["50mcg", "100mcg"] },
  { name: "Nexito", category: "Mental Health", dosages: ["5mg", "10mg", "20mg"] },
  { name: "Restyl", category: "Mental Health", dosages: ["0.25mg", "0.5mg"] },
  { name: "Prothiaden", category: "Mental Health", dosages: ["25mg", "75mg"] },
];

// Frequency options
export const FREQUENCY_OPTIONS = [
  { value: "once_daily", en: "Once daily", hi: "दिन में एक बार" },
  { value: "twice_daily", en: "Twice daily", hi: "दिन में दो बार" },
  { value: "thrice_daily", en: "Three times daily", hi: "दिन में तीन बार" },
  { value: "four_times", en: "Four times daily", hi: "दिन में चार बार" },
  { value: "every_6_hours", en: "Every 6 hours", hi: "हर 6 घंटे" },
  { value: "every_8_hours", en: "Every 8 hours", hi: "हर 8 घंटे" },
  { value: "every_12_hours", en: "Every 12 hours", hi: "हर 12 घंटे" },
  { value: "once_weekly", en: "Once weekly", hi: "हफ्ते में एक बार" },
  { value: "as_needed", en: "As needed (SOS)", hi: "जरूरत पर (SOS)" },
  { value: "before_bed", en: "Before bed", hi: "सोने से पहले" },
];

// Timing options
export const TIMING_OPTIONS = [
  { value: "before_food", en: "Before food", hi: "खाने से पहले" },
  { value: "after_food", en: "After food", hi: "खाने के बाद" },
  { value: "with_food", en: "With food", hi: "खाने के साथ" },
  { value: "empty_stomach", en: "Empty stomach", hi: "खाली पेट" },
  { value: "any_time", en: "Any time", hi: "कभी भी" },
];

// Duration options
export const DURATION_OPTIONS = [
  { value: "3_days", en: "3 days", hi: "3 दिन" },
  { value: "5_days", en: "5 days", hi: "5 दिन" },
  { value: "7_days", en: "7 days", hi: "7 दिन" },
  { value: "10_days", en: "10 days", hi: "10 दिन" },
  { value: "14_days", en: "14 days", hi: "14 दिन" },
  { value: "1_month", en: "1 month", hi: "1 महीना" },
  { value: "2_months", en: "2 months", hi: "2 महीने" },
  { value: "3_months", en: "3 months", hi: "3 महीने" },
  { value: "6_months", en: "6 months", hi: "6 महीने" },
  { value: "ongoing", en: "Ongoing / Continuous", hi: "लगातार / जारी" },
];

// Search function
export const searchMedicines = (query) => {
  if (!query || query.length < 2) return [];
  
  const lowerQuery = query.toLowerCase();
  
  return MEDICINES_DATABASE
    .filter(med => med.name.toLowerCase().includes(lowerQuery))
    .slice(0, 10) // Limit to 10 results
    .map(med => ({
      ...med,
      displayName: med.name,
    }));
};
